export const percentageRegExp = /^(100(\.0{1,3})?|\d{0,2}(\.\d{1,2})?)%?$/;
export const percentageRegExpWithoutSymbol = /^(100(\.0{1,3})?|\d{0,2}(\.\d{1,2})?)$/;
export const positiveNumberWithDecimal = /^(?!.*[^\d.])\d+(\.\d+)?$/;
export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const numberRegExp = /^[0-9]+$/;
export const urlRegExp = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(\/[\w .-]*)*\/?(\?[^#\s]*)?(#[\w-]*)?$/;
export const noSpaceRegExp = /^(?!\s).*\S$/;
export const italyPhoneNumberRegExp = /^[0-9()+\-\s]*$/;
export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const rules = {
  global: function (name: string) {
    return { required: `${name} is required` };
  },
  maxValidation: function (maxValue: number, name: string = "", applyGlobal: boolean = false) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      max: {
        value: maxValue,
        message: `value must be less than ${maxValue}`
      }
    };
  },
  minLength: function (minValue: number, name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      minLength: {
        value: minValue,
        message: `${name} must be at least ${minValue} characters.`
      }
    };
  },
  percentage: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: percentageRegExp,
        message: "Enter valid percentage"
      }
    };
  },
  decimalNumber: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: positiveNumberWithDecimal,
        message: "Enter a valid Number"
      }
    };
  },
  Number: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: numberRegExp,
        message: "Enter a valid Number"
      }
    };
  },
  email: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: emailRegExp,
        message: "Enter valid email"
      }
    };
  },
  emailOptional: function () {
    // const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      // ...globalRule,
      pattern: {
        value: emailRegExp,
        message: "Enter valid email"
      }
    };
  },
  url: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: urlRegExp,
        message: "Enter valid Url"
      }
    };
  },
  noSpaces: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      validate: (value: string) => {
        if (!value) return true; // Allow empty string if not required
        return noSpaceRegExp.test(value) || `${name} cannot start or end with spaces`;
      }
    };
  },
  italyPhoneNumber: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: italyPhoneNumberRegExp,
        message: "Enter valid Phone Number"
      }
    };
  },
  password: function (name: string = "", applyGlobal: boolean = true) {
    const globalRule = applyGlobal ? rules.global(name) : {};
    return {
      ...globalRule,
      pattern: {
        value: passwordRegExp,
        message:
          "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character, and be at least 8 characters long."
      }
    };
  }
};
